<div *ngIf="_islog == true; then logHeader else unLogHeader"></div>
<ng-template #logHeader>
  <app-auth-header   (menuEmit)="toggleSideNav()"  ></app-auth-header>
</ng-template>
<ng-template #unLogHeader>
  <app-offline-header   (menuEmit)="toggleSideNav()"  ></app-offline-header>
</ng-template>